export default __webpack_public_path__ + "static/media/rotatevector2.b0b0649c.svg";